import React from 'react';

const Master = ({
  width = 33,
  height = 20,
  id,
}: {
  width?: number;
  height?: number;
  id?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={id}
  >
    <path d="M21.324 2.139H12.67v15.724h8.655V2.139Z" fill="#FF5F00" />
    <path
      d="M13.217 10c-.002-1.514.338-3.01.992-4.371a9.963 9.963 0 0 1 2.786-3.491A9.797 9.797 0 0 0 6.559 1.006a9.93 9.93 0 0 0-4.061 3.689A10.081 10.081 0 0 0 .99 10c0 1.876.522 3.715 1.507 5.305a9.93 9.93 0 0 0 4.061 3.69 9.798 9.798 0 0 0 10.436-1.133 9.963 9.963 0 0 1-2.786-3.49A10.072 10.072 0 0 1 13.217 10Z"
      fill="#EB001B"
    />
    <path
      d="M33 10a10.08 10.08 0 0 1-1.507 5.305 9.93 9.93 0 0 1-4.061 3.69 9.797 9.797 0 0 1-10.435-1.133 9.981 9.981 0 0 0 2.783-3.492 10.093 10.093 0 0 0 0-8.74 9.981 9.981 0 0 0-2.783-3.492 9.797 9.797 0 0 1 10.435-1.132 9.93 9.93 0 0 1 4.061 3.689A10.08 10.08 0 0 1 33 10ZM32.052 16.199v-.322h.128v-.066h-.327v.066h.128v.322h.07Zm.634 0v-.389h-.1l-.115.268-.115-.268h-.1v.389h.07v-.293l.108.252h.074l.108-.253v.294h.07Z"
      fill="#F79E1B"
    />
  </svg>
);

export default Master;
